import React, { useEffect, useState } from 'react';
import { RFValue } from 'react-native-responsive-fontsize';

import {
  Keyboard,
  KeyboardAvoidingView,
  Platform,
  TouchableWithoutFeedback,
  Text,
} from 'react-native';
import { Header } from '../../components/Interface/Headers/Header';

import {
  Container,
  Content,
  Form,
  FormButton,
  FormButtonIcon,
  FormButtonText,
  HelpVideoContainer,
  HelpVideoSubtitle,
  HelpVideoThumb,
  HelpVideoTitle,
  VideoInfos,
  SecurityCard,
  SecurityCardText,
} from './styles';

import { Titles } from '../../components/Interface/Typographies/Titles';
import { useTheme } from 'styled-components/native';
import { RootStackParamList } from '../../dtos/RoutesDTO';
import { NativeStackScreenProps } from 'react-native-screens/lib/typescript/native-stack/types';
import { useAuth } from '../../context/auth';
import { SafeAreaView } from 'react-native-safe-area-context';
import { HelpVideo } from '../../components/shared/HelpVideo';
import thumbVideo from '../../assets/images/banners/thumb-reembolso.webp';
import { useRemoteConfig } from '../../context/useRemoteConfig';
import { useGlobal } from '../../context/global';
import { Maintenance } from '../../components/Interface/Maintenance';

type ScreenProps = NativeStackScreenProps<RootStackParamList, 'Reembolsos'>;

export function Reembolsos({ navigation }: ScreenProps) {

  const theme = useTheme();
  const [showVideo, setShowVideo] = useState(false);

  const { isLogged } = useAuth();
  const { reembolsoTextoInicial } = useRemoteConfig(true);
  const { disabledFeatures } = useGlobal();
  const isDisabled = (key: string) => disabledFeatures.includes(key);

  const parseRemoteText = (value?: string) => {
    if (!value) return null;
    try {
      const parsed = JSON.parse(value);
      if (
        Array.isArray(parsed) &&
        parsed.every(
          (item) =>
            item &&
            typeof item.value === 'string' &&
            (item.type === 'text' || item.type === 'textBold'),
        )
      ) {
        return parsed as {type: 'text' | 'textBold'; value: string}[];
      }
    } catch {
      return null;
    }

    return null;
  };

  useEffect(() => {
    if (!isLogged) {
      navigation.navigate('Home');
    }
  }, [isLogged]);

  if (isDisabled('reembolso')) {
    return <Maintenance />;
  }

  return (
    <SafeAreaView edges={['bottom']} style={{ flex: 1 }}>
      <TouchableWithoutFeedback onPress={() => Platform.OS !== "web" && Keyboard.dismiss()}>
        <Container>
          <KeyboardAvoidingView
            behavior="position"
            contentContainerStyle={{ paddingBottom: RFValue(20) }}>
            <HelpVideoContainer
              onPress={() => setShowVideo(true)}
              activeOpacity={1}>
              <HelpVideoThumb source={thumbVideo}>
                <Header
                  icon="chevron-left"
                  statusBarLight
                  color={theme.colors.shape}
                />
                <VideoInfos>
                  <HelpVideoTitle>Como solicitar reembolso?</HelpVideoTitle>
                  <HelpVideoSubtitle>
                    Clique e veja o passo a passo
                  </HelpVideoSubtitle>
                </VideoInfos>
              </HelpVideoThumb>
            </HelpVideoContainer>

            <Content>
              <Titles
                title="O que deseja fazer?"
                subtitle="Solicite um novo reembolso ou acompanhe um já existente."
              />

              <Form style={{ marginTop: -RFValue(12) }}>
                <FormButton
                  onPress={() => navigation.navigate('SolicitaReembolso')}
                  underlayColor={theme.colors.button_click_bg}>
                  <>
                    <FormButtonText>Solicitar reembolso</FormButtonText>
                    <FormButtonIcon name="chevron-right" />
                  </>
                </FormButton>
              </Form>
              <Form>
                <FormButton
                  onPress={() => navigation.navigate('PedidosReembolso')}
                  underlayColor={theme.colors.button_click_bg}>
                  <>
                    <FormButtonText>Acompanhar pedidos</FormButtonText>
                    <FormButtonIcon name="chevron-right" />
                  </>
                </FormButton>
              </Form>
              <SecurityCard>
                <SecurityCardText>
                  {(() => {
                    const parsed = parseRemoteText(reembolsoTextoInicial);
                    if (parsed) {
                      return parsed.map((item, index) => (
                        <Text
                          key={`${item.type}-${index}`}
                          style={{
                            fontFamily:
                              item.type === 'textBold'
                                ? theme.fonts.semibold
                                : theme.fonts.regular,
                          }}>
                          {item.value}
                          {index < parsed.length - 1 ? '\n\n' : ''}
                        </Text>
                      ));
                    }

                    return (
                      reembolsoTextoInicial ||
                      'Por segurança, o reembolso só pode ser realizado para o mesmo CPF que efetuou o pagamento.\n\nEssa regra segue as normas do Banco Central e existe para evitar fraudes e garantir que o valor seja devolvido corretamente ao titular da compra.'
                    );
                  })()}
                </SecurityCardText>
              </SecurityCard>
            </Content>
          </KeyboardAvoidingView>

          {showVideo && (
            <HelpVideo
              onVideoEnd={() => setShowVideo(false)}
              videoURI="https://barataocombustiveis.s3.sa-east-1.amazonaws.com/REEMBOLSO.mp4"
            />
          )}
        </Container>
      </TouchableWithoutFeedback>
    </SafeAreaView>
  );
}
